import React from "react";
import { SidebarFormProps } from "./SidebarForm";
import { Input, ToggleSwitch } from "../../../../components";
import { useTranslations } from "../../../../contexts";
import { DesignerSectionHeading } from "./DesignerSectionHeading";

type SidebarContactFormProps = SidebarFormProps;

export const SidebarContactForm: React.FC<SidebarContactFormProps> = (
  props
) => {
  const i18n = useTranslations();

  return (
    <div id="contact-form" className="p-6" data-preview-section="contact">
      <div className="flex items-start">
        <DesignerSectionHeading
          className="grow pb-4"
          title={i18n.contactForm}
          helpLabel={`${i18n.designerHelpFor} ${i18n.contactForm}`}
          helpText={i18n.designerContactHelp}
        />
        <ToggleSwitch
          aria-label={`${i18n.designerShowSection}: ${i18n.contactForm}`}
          checked={props.form.contactForm?.is_enabled}
          onChange={() =>
            props.setForm({
              ...props.form,
              contactForm: {
                ...props.form.contactForm,
                is_enabled: !props.form.contactForm?.is_enabled,
              },
            })
          }
        />
      </div>
      {props.form.contactForm?.is_enabled && (
        <div>
          <Input
            className="mb-2"
            placeholder={i18n["title"]}
            example={i18n.designerContactTitlePlaceholder}
            help={{
              label: `${i18n.designerHelpFor} ${i18n.title}`,
              content: i18n.designerContactTitleHelp,
            }}
            value={props.form.contactForm.title || undefined}
            onChange={(event) =>
              props.setForm({
                ...props.form,
                contactForm: {
                  ...props.form.contactForm,
                  title: event.target.value,
                },
              })
            }
          />
          <Input
            variant="outlined"
            placeholder={i18n.description}
            example={i18n.designerContactDescriptionPlaceholder}
            help={{
              label: `${i18n.designerHelpFor} ${i18n.description}`,
              content: i18n.designerContactDescriptionHelp,
            }}
            value={props.form.contactForm.description || undefined}
            onChange={(event) =>
              props.setForm({
                ...props.form,
                contactForm: {
                  ...props.form.contactForm,
                  description: event.target.value,
                },
              })
            }
          />
        </div>
      )}
    </div>
  );
};
